@if (!success) {
  <gl-right>
    <div class="right-options">
      <div class="account-register-sign">
        @if (!(isMobile && isLpCampaign)) {
          <p>
            {{
            whiteLabel.logoUrl
            ? ('already_have_account_wl' | translate)
            : ('already_have_account' | translate)
            }}
          </p>
        }
        <a data-ctx="button-on-login" (click)="onLogin()" normal-link>{{ 'sign_in' | translate }}</a>
      </div>
      <gl-languages></gl-languages>
    </div>
    <div class="container">
      <h2 class="title">{{ 'register' | translate }}</h2>
      <div class="social-buttons">
        @if (!isQueryEmail) {
          <button
            google-button
            id="{{ isMobile ? 'mobi-google' : 'desk-google' }}"
            (click)="loginWithGoogle()"
            type="button"
            >
            {{ 'google' | translate }}
          </button>
        }
        @if (!isQueryEmail) {
          <button
            trans-button
            id="{{ isMobile ? 'mobi-trans' : 'desk-trans' }}"
            (click)="loginWithTrans()"
            type="button"
            class="trans-button"
          ></button>
        }
        @if (!isQueryEmail) {
          <button
            facebook-button
            id="{{ isMobile ? 'mobi-face' : 'desk-face' }}"
            (click)="loginWithFacebook()"
            type="button"
          ></button>
        }
      </div>
      @if (isFirstPart) {
        <form [formGroup]="formPart1" (ngSubmit)="onSubmitPart1()">
          <gl-input-container [errorAboveInput]="true"
            [isErrorVisible]="isFormPart1Submitted && formPart1.controls.email.invalid">
            <input type="text" placeholder="email_adress" normal-input formControlName="email" />
          </gl-input-container>
          <gl-input-container [errorAboveInput]="true" class="passwordContainer">
            <input
              type="password"
              placeholder="password_with_hint"
              normal-input
              formControlName="password"
              />
          </gl-input-container>
          <gl-input-container [errorAboveInput]="true">
            <input
              type="password"
              placeholder="repeat_password"
              normal-input
              formControlName="retypedPassword"
              />
          </gl-input-container>
          <gl-select placeholder="activity_type" formControlName="activityType" [errorAboveInput]="true"
            (selectionChange)="activityTypeChange($event)">
            @for (activity of activityTypes; track activity) {
              <gl-option [value]="activity" [label]="activity"></gl-option>
            }
          </gl-select>
          @if (this.formPart1.get('activityType').value !== null) {
            <gl-select
              placeholder="activity_area"
              formControlName="activityArea"
              [errorAboveInput]="true"
              >
              @for (activityArea of activityAreas; track activityArea) {
                <gl-option
                  [value]="activityArea"
                  [label]="activityArea">
                </gl-option>
              }
            </gl-select>
          }
          <button type="submit" class="submit" normal-big-button>{{ 'step_2_of_2' | translate }}</button>
        </form>
      }
      @if (isSecondPart) {
        <form [formGroup]="formPart2" (ngSubmit)="onSubmitPart2()">
          <gl-select placeholder="position" formControlName="position" [errorAboveInput]="true">
            @for (position of positions; track position) {
              <gl-option [value]="position" [label]="position"></gl-option>
            }
          </gl-select>
          @if (!isEdu) {
            <gl-input-container [errorAboveInput]="true">
              <input type="text" placeholder="company_name" normal-input formControlName="organizationName" />
            </gl-input-container>
          }
          @if (isEdu) {
            <gl-input-container [errorAboveInput]="true">
              <input type="text" placeholder="school_name" normal-input formControlName="organizationName" />
            </gl-input-container>
          }
          @if (isEdu) {
            <gl-input-container [errorAboveInput]="true">
              <input type="text" placeholder="city" normal-input formControlName="city" />
            </gl-input-container>
          }
          <gl-select
            placeholder="country"
            formControlName="country"
            [searchOption]="true"
            (searchEmit)="onSearch($event)"
            [errorAboveInput]="true"
            >
            @for (country of countries; track country) {
              <gl-option [value]="country" [label]="country"></gl-option>
            }
          </gl-select>
          @if (!isEdu) {
            <gl-input-container [errorAboveInput]="true">
              <input type="text" placeholder="vat_id" normal-input formControlName="vatId" />
            </gl-input-container>
          }
          <div class="privacyPolicyContainer">
            <gl-checkbox
              formControlName="acceptedTermsOfServiceAndPrivacyPolicy"
              [defaultChecked]="false"
              class="rules-and-policy"
              >
              <p>
                {{ 'register_rules_privacy_policy_message' | translate }}
                <a (click)="goTo($event, regulationsLink)" normal-link>{{ 'rules' | translate }}</a>
                {{ 'and' | translate }}
                <a (click)="goTo($event, privacyPolicyLink)" normal-link>{{
                  'privacy_policy' | translate
                  }}</a
                  >.
                </p>
              </gl-checkbox>
            </div>
            <div class="buttons">
              <button type="button" class="back" normal-big-button
                (click)="backButtonClick($event)">{{ 'back' | translate }}
              </button>
              <button type="submit" class="submit" normal-big-button>{{ 'sign_up' | translate }}</button>
            </div>
          </form>
        }
      </div>
    </gl-right>
  }
  @if (success) {
    <gl-right [success]="true">
      <h2>{{ 'register_success_header' | translate }}</h2>
      <p>{{ successMessage | translate: getTranslationObject() }}</p>
    </gl-right>
  }
